export const Styles = (theme) => ({
  header: {
    margin: "0.3em",
    padding: "2px 0.2em 2px 1em",
    cursor: "pointer",
    border: "0",
    color: "#053674",
    fontWeight: "bold",
  },
  maxIcon: {
    float: "right",
    color: "grey",
    cursor: "pointer",
  },
  ContainerMaximized: {
    position: "fixed",
    width: "80%",
    height: "450px",
    left: "40%",
    top: "50%",
    marginTop: "-225px",
    marginLeft: "-30%",
    boxShadow: "2px 2px 5px 2px transparent",
  },
  table: {
    width: "90%",
    alignSelf: "center",
    marginLeft: "auto",
    marginRight: "auto",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: "fit-content",
  },
  container1: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    padding :"0px 20px 10px 20px",
    marginTop: "-10px",
  },
  search: {
    [theme.breakpoints.down("sm")]: {
      marginLeft: "2px",
    },
  },
  button: {
    marginTop: "1px",
    marginRight: "4px",
    marginBottom: "8px",
    marginLeft: " 5px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "8px",
      width: "80px",
    },
  },
  button2:{
    color: "#fff",
    backgroundColor: "#0089cf",
    borderColor: "#0089cf",
    "&:hover":{
      color: "#fff",
      backgroundColor: "#243a6f",
      borderColor: "#243a6f",
    },
  },
  Checkblock: {
    marginRight: "7px",
    padding: "8px",
  },
  checkcontainer: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
  },
  checkboxlebel: {
    color: "rgb(5,54,116)",
    fontWeight: "600",
    fontSize: ".8em",
  },
  dashBoardCheckbox: {
    width: "245px",
  },
  popContainer: {
    width: "60%",
    height: "100%",
    textAlign: "center",
    marginTop: "20px",
    marginRight: "auto",
    marginLeft: "auto",
  },
  header2: {
    margin: "0.4em",
    padding: "2px 0.2em 2px 1em",
    //cursor: "move",
    border: "0",
    color: "#053674",
    fontWeight: "bold",
    cursor: "pointer",
  },
  applHeading1: {
    width: "313px",
    height: "20px",
    marginTop: "15px",
    marginBottom: "5px",
    fontSize: "15px",
    padding: "0px",
  },
  applSubHeading: {
    marginBottom: ".5em",
    fontSize: ".9em",
    fontWeight: "500",
    color: "#333 !important",
    paddingTop: ".5em",
    display: "inline-block",
    width: "150px",
  },
  closePop: {
    float: "right",
    color: "grey",
    cursor: "pointer",
    marginBottom: "35px",
    marginLeft: "15px",
  },
  dounghoutContainer: {
    width: "10%",
    height: "10%",
    textAlign: "center",
    marginTop: "20px",
    marginRight: "auto",
    marginLeft: "auto",
  },
  textFieldSelect: {
    // marginLeft: "25px",
    width: "180px",
    height: "30px",
    marginTop: "7px",
    fontSize: "1rem",
    marginBottom: "20px",
    padding: "0px",
  },
  panelBody: {
    width: "100%",
  },
  label: {
    fontSize: "1.1rem",
    fontWeight: "600",
    minWidth: "165%",
    color: "#053674 !important",
    marginBottom: "12px",
  },
  validationMessage: {
    color: "red !important",
    fontSize: "12px !important",
    marginLeft: "0px",
    width: "180px",
    position:"absolute"
  },
  input: {
    display: "flex",
    padding: 0,
    marginTop: "1px",
  },
  paper: {
    position: "absolute",
    zIndex: 1,
    marginTop: theme.spacing.unit,
    //width: "180px",
    left: 0,
    right: 0,
  },
  valueContainer: {
    display: "flex",
    flexWrap: "wrap",
    flex: 1,
    alignItems: "left",
    overflow: "hidden",
    fontSize: "0.95em",
    padding: ".2em .5em",
    backgroundColor: "#FFFFFF",
    borderWidth: "0",
    border: "1px solid #999 !important",
    borderRight: "0px !important",

    // minWidth: "12em",
    maxHeight: "1.9em",
    borderRadius: "5px 0px 0px 5px",
    //  boxShadow: "0px 1px #999"
  },
  mobileWidth: {
    width: "70% !important",
    padding: "0px !important",
    maxHeight: "75vh !important",
    overflowY: "auto !important",

    [theme.breakpoints.down("xs")]: {
      marginTop: "70px !important",
      width: "150% !important",
      maxHeight: "100vh !important",
      overflowY: "auto !important",
      shrink: "true !important",
    },
  },

  space: {
    marginLeft: "270px",
    marginTop: "15px",
    cursor: "pointer",
    height: "340px",
  },
  chartContainer2: {
    width: "350px",
    height: "230px",
    position: "relative",
    display: "inline-block",
    overflow: "hidden",
    cursor: "pointer",
  },
  chartContainer3: {
    display: "block",
    position: "absolute",
    top: "50%",
    left: "50%",
    minHeight: "100%",
    minWidth: "100%",
    transform: "translate(-50%, -50%)",
  },

  centreAlign: {
   marginTop: "75px",
   marginLeft: "75px",
  },

  centreAlign1:{
    marginTop: "150px",
  },

  expansionPanelbuttons: { marginTop: "15px" },
});
